export default __webpack_public_path__ + "static/media/download_light.794348d2.svg";